
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"49","height":"43","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"stroke":"#CCC","d":"M6.4 1.5a4.9 4.9 0 00-4.9 4.9v19.749a4.9 4.9 0 004.9 4.9h6.777v8.658a1.3 1.3 0 002.21.927l9.753-9.585H42.6a4.9 4.9 0 004.9-4.9V6.4a4.9 4.9 0 00-4.9-4.9H6.4z","stroke-linejoin":"square","fill":"#F9F9F9"}}),_c('path',{attrs:{"stroke":"#FFF","d":"M25.55 32.049l-9.461 9.298a2.3 2.3 0 01-3.912-1.64v-7.658H6.4a5.9 5.9 0 01-5.9-5.9V6.4A5.9 5.9 0 016.4.5h36.2a5.9 5.9 0 015.9 5.9v19.749a5.9 5.9 0 01-5.9 5.9H25.55z"}})])])
          )
        }
      }
    